export const NumberFormatter = () => {
  const formatCount = (count: number): string => {
    return Intl.NumberFormat('de-DE').format(count);
  };

  const formatAverage = (average: number): string => {
    return Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(average);
  };

  return {
    formatCount,
    formatAverage,
  };
};
